var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-magnifier-container"},[_vm._t("default"),_c('span',{ref:"magnificationElement",staticClass:"preview",style:({ backgroundImage: ("url('" + _vm.src + "')") })},[_c('span',{ref:"glass",staticClass:"magnifying-glass",style:({
        backgroundImage: ("url('" + _vm.srcLarge + "')"),
        backgroundPosition: _vm.backgroundPos,
        left: (_vm.cursorX + "px"),
        top: (_vm.cursorY + "px"),
      })})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }